<div class="t-widget--noPadding">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.supplyOrdersLabSummaryTitle" | translate }}
    </h2>
    <hr />
  </header>
  <div
    class="summary-row"
    [class.allow-hover]="data.openDeliveryOrdersCnt > 0"
    (click)="
      data.openDeliveryOrdersCnt > 0 ? filterOpenSupplyOrders(true, true) : null
    "
  >
    <p class="lbl">
      {{ "translate.dashboard.openDeliveryOrders" | translate }}
    </p>
    <p class="value">{{ data.openDeliveryOrdersCnt | number }}</p>
  </div>
  <div
    class="summary-row"
    [class.allow-hover]="data.openSuppliesOrdersCnt > 0"
    (click)="
      data.openSuppliesOrdersCnt > 0
        ? filterOpenSupplyOrders(false, true)
        : null
    "
  >
    <p class="lbl">
      {{ "translate.dashboard.openSupplyOrders" | translate }}
    </p>
    <p class="value">{{ data.openSuppliesOrdersCnt | number }}</p>
  </div>

  <div
    class="summary-row"
    [class.allow-hover]="data.closedDeliveryOrdersCnt > 0"
    (click)="
      data.closedDeliveryOrdersCnt > 0
        ? filterOpenSupplyOrders(true, false)
        : null
    "
  >
    <p class="lbl">
      {{ "translate.dashboard.closedDeliveryOrders" | translate }}
    </p>
    <p class="value">{{ data.closedDeliveryOrdersCnt | number }}</p>
  </div>
  <div
    class="summary-row"
    [class.allow-hover]="data.closedSuppliesOrdersCnt > 0"
    (click)="
      data.closedSuppliesOrdersCnt > 0
        ? filterOpenSupplyOrders(false, false)
        : null
    "
  >
    <p class="lbl">
      {{ "translate.dashboard.closedSupplyOrders" | translate }}
    </p>
    <p class="value">{{ data.closedSuppliesOrdersCnt | number }}</p>
  </div>

  <div class="box-buttons t-buttonSet l-align-spaceBetween summary-box-footer">
    <button (click)="goToDeliveryOrder()" class="t-button-outline">
      {{ "translate.dashboard.goToDeliveryOrder" | translate }}
    </button>

    <button (click)="goToSuppliesOrder()" class="t-button-outline">
      {{ "translate.dashboard.goToSuppliesOrder" | translate }}
    </button>
  </div>
</div>
